import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { DateRangePicker } from '../date-range-picker';
import { getTimePeriodInDays, getMomentInstance } from '@wix/answers-lib';
export var DateRangeCompareKey = 'date-range-compare';
var DateRangeCompare = /** @class */ (function (_super) {
    __extends(DateRangeCompare, _super);
    function DateRangeCompare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calendarTheme = {
            Calendar: { width: 300, color: '#577083', background: '#fcfcfc' },
            PredefinedRanges: { display: 'none' },
            PredefinedRangesItem: {
                background: '#ffffff', color: '#445868', fontSize: 14, paddingTop: 8, paddingBottom: 8, paddingLeft: 12, margin: 0
            },
            PredefinedRangesItemActive: { background: '#f2f8fd', color: '#445868' },
            MonthAndYear: { fontWeight: 300, fontSize: 16, marginTop: 5, marginBottom: 5 },
            Weekday: { fontWeight: 500, fontSize: 16, marginTop: 5 },
            DaySelected: { background: '#445868' },
            DayInRange: { color: '#fcfcfc', background: '#577083' },
            MonthButton: { background: '#fcfcfc', color: '#445868' },
        };
        _this.state = {};
        _this.getCompareRangeSize = function () {
            return getTimePeriodInDays(_this.props.compareTo.startDate, _this.props.compareTo.endDate) || 0;
        };
        _this.getLastSelectableDate = function () {
            var ts = new Date(_this.props.compareTo.startDate).valueOf();
            return getMomentInstance(ts).subtract(1, 'day').format('YYYY-MM-DD');
        };
        return _this;
    }
    DateRangeCompare.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames(DateRangeCompareKey, props.className);
        var compareRangeSize = this.getCompareRangeSize();
        var maxDate = this.getLastSelectableDate();
        return (React.createElement("div", { className: classNames },
            React.createElement(DateRangePicker, { value: props.value, onChange: props.onChange, compareModeRangeSize: compareRangeSize, minDate: this.props.minDate, maxDate: maxDate, theme: this.calendarTheme, locale: props.locale })));
    };
    return DateRangeCompare;
}(React.PureComponent));
export { DateRangeCompare };
//# sourceMappingURL=index.js.map